import "./PricingHero.css";

const PricingHero = ({ title, subtitle }) => {
	return (
		<div className="pricing-hero">
			<h1 className="pricing-hero-title">{title}</h1>
			<p className="pricing-hero-subtitle">{subtitle}</p>
		</div>
	);
};

export default PricingHero;
